import * as moment from 'moment';

export class DisplayFunctions {
  public static getRemainingDays(str: string): string {
    const diff = new Date(str).getTime() - new Date().getTime();
    const days = Math.ceil(diff / (24 * 60 * 60 * 1000));
    let daysWord = 'dni';
    if (days === 1) {
      daysWord = 'dzień';
    }
    return `${days} ${daysWord}`;
  }

  public static getDateWithoutHours(str: string): string {
    return str.substring(0, 10);
  }

  public static getStatus(str: string): string {
    switch (str.toUpperCase()) {
      case 'PENDING': {
        return 'oczekujące';
      }
      case 'SENT': {
        return 'wysłane';
      }
      case 'CANCELED': {
        return 'anulowane';
      }
      default: {
        return 'oczekujące';
      }
    }
  }

  public static getStatusStyle(str: string): string {
    switch (str.toUpperCase()) {
      case 'PENDING': {
        return 'waiting';
      }
      case 'SENT': {
        return 'sent';
      }
      case 'CANCELED': {
        return 'canceled';
      }
      default: {
        return 'waiting';
      }
    }
  }

  public static getTypeStyle(str: string): string {
    switch (str.toUpperCase()) {
      case 'TOP SELLER': {
        return 'top-seller';
      }
      case 'NOWOŚĆ': {
        return 'novelty';
      }
      case 'PROMOCJA': {
        return 'promotion';
      }
      case 'KOMUNIKAT': {
        return 'announcement';
      }
      default: {
        return '';
      }
    }
  }

  public static getDisplayValue(param: any, type = 'inline'): string {
    return !param || ['NaN', 'undefined', 'null', '0'].indexOf(param) > -1 ? 'none' : type;
  }

  public static getPolishPriceFormat(str: string): string {
    if (!str) {
      return '';
    }

    const formatter = new Intl.NumberFormat('pl-PL', {
      style: 'currency',
      currency: 'PLN',
    });

    return formatter.format(Number(str));
  }

  public static formatDateDDMMYYYY(date: string): string {
    return DisplayFunctions.formatDateWithPattern(date, 'DD.MM.YYYY');
  }

  public static formatDateHHMMDDMMYYYY(date: string): string {
    return DisplayFunctions.formatDateWithPattern(date, 'HH:mm DD.MM.YYYY');
  }

  public static formatDateDDMMYYYYHHMM(date: string): string {
    return DisplayFunctions.formatDateWithPattern(date, 'DD.MM.YYYY HH:mm');
  }

  private static formatDateWithPattern(date: string, pattern: string) {
    if (moment(date).isValid()) {
      return moment(date).format(pattern).toString();
    }
    return '--';
  }

  public static isDateGreaterThanNow(date: string): boolean {
    return moment(date).isAfter(moment());
  }
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/utils/display-functions.class.ts